<div class="app">
  <div class="split-pane" [class.open]="menuOpened$()">
    <aside class="side-menu" [class.expanded]="menuOpened$()" [class.hidden]="(fullScreenPage$ | async) || (authService.isAuthenticated$ | async) === false">
      <header class="side-menu__header">
        <div class="side-menu__toolbar">
          <div id="logo-container"></div>
        </div>
      </header>

      <div class="side-menu__content">
        <nav class="menu-nav">
          <ng-template #menuItemTpl let-icon="icon" let-label="label" let-link="link" let-disabled="disabled">
            @if (disabled) {
              <span class="menu-item disabled" aria-disabled="true">
                <mat-icon [svgIcon]="icon"></mat-icon>
                <span class="menu-label">{{ label }}</span>
              </span>
            } @else {
              <a
                class="menu-item"
                [routerLink]="link"
                [replaceUrl]="true"
                routerLinkActive="active"
                [attr.data-testid]="'nav-' + label.toLowerCase().replaceAll(' ', '-') + '-link'"
              >
                <mat-icon [svgIcon]="icon"></mat-icon>
                <span class="menu-label">{{ label }}</span>
              </a>
            }
          </ng-template>

          <ng-template #dividerTpl let-label="label">
            @if (menuOpened$()) {
              <div class="menu-divider">
                <span class="menu-label">{{ label }}</span>
              </div>
            }
          </ng-template>

          <div *hasPermission="[userPermission.ManageProjects]" class="main-item">
            <eiq-button
              text="New Project"
              title="New Project"
              [testId]="'nav-new-project'"
              [icon]="menuOpened$() ? null : faPlus"
              [expand]="'full'"
              [size]="'medium'"
              [style]="menuOpened$() ? 'flat' : 'icon'"
              (clicked)="onNewProject()"
            ></eiq-button>
          </div>

          <ng-container *ngTemplateOutlet="menuItemTpl; context: { icon: 'home', label: 'Home', link: '/', disabled: true }"></ng-container>
          <ng-container
            *hasPermission="[userPermission.ManageProjects, userPermission.EditProjects, userPermission.ViewProjects, userPermission.ViewProjectsPrelaunch]"
          >
            <ng-container *ngTemplateOutlet="menuItemTpl; context: { icon: 'projects', label: 'Projects', link: '/projects' }"></ng-container>
          </ng-container>

          <div *hasPermission="[userPermission.ViewResearchAssistant, userPermission.ManagePolls]" class="menu-section">
            <ng-container *ngTemplateOutlet="dividerTpl; context: { label: 'INSIGHTS' }"></ng-container>
            <ng-container *hasPermission="[userPermission.ViewResearchAssistant]">
              @if (researchAssistantEnabled) {
                <ng-container
                  *ngTemplateOutlet="menuItemTpl; context: { icon: 'deepsights', label: 'Insight Navigator', link: '/insight-navigator' }"
                ></ng-container>
              }
            </ng-container>
            <ng-container *hasPermission="[userPermission.ManagePolls]">
              <ng-container
                *ngTemplateOutlet="menuItemTpl; context: { icon: 'dailypolls', label: 'Daily Polls', link: '/polls', disabled: true }"
              ></ng-container>
            </ng-container>
          </div>

          <div *hasPermission="[userPermission.ViewTrustCentre]" class="menu-section">
            <ng-container *ngTemplateOutlet="dividerTpl; context: { label: 'QUALITY MONITOR' }"></ng-container>
            <ng-container
              *ngTemplateOutlet="menuItemTpl; context: { icon: 'shield', label: 'Trust Centre', link: '/trust-centre', disabled: false }"
            ></ng-container>
          </div>
          <div *hasPermission="[userPermission.ManagePanels]" class="menu-section">
            <ng-container *ngTemplateOutlet="dividerTpl; context: { label: 'PANELS' }"></ng-container>
            <ng-container
              *ngTemplateOutlet="menuItemTpl; context: { icon: 'panelistmanager', label: 'Panelist Manager', link: '/panel-members/management' }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="menuItemTpl; context: { icon: 'registrations', label: 'Registrations', link: '/panel-members/registrations' }"
            ></ng-container>
            <ng-container *ngTemplateOutlet="menuItemTpl; context: { icon: 'subpanels', label: 'Sub Panels', link: '/panels', disabled: true }"></ng-container>
            <ng-container
              *ngTemplateOutlet="menuItemTpl; context: { icon: 'rewards', label: 'Rewards Redemptions', link: '/panel-members/rewards', disabled: true }"
            ></ng-container>
            <ng-container *hasPermission="[userPermission.ManageClients]">
              <ng-container
                *ngTemplateOutlet="menuItemTpl; context: { icon: 'clipboard-user', label: 'Client Registrations', link: '/clients' }"
              ></ng-container>
              <ng-container
                *ngTemplateOutlet="menuItemTpl; context: { icon: 'clients', label: 'Client Brief Requests', link: '/client-brief-requests' }"
              ></ng-container>
            </ng-container>
          </div>

          <div
            *hasPermission="[userPermission.ViewUsage, userPermission.ManageUsers, userPermission.ViewUsers, userPermission.ManageSystemSettings]"
            class="menu-section"
          >
            <ng-container *ngTemplateOutlet="dividerTpl; context: { label: 'ACCOUNT' }"></ng-container>
            <ng-container *hasPermission="[userPermission.ViewUsage]">
              <ng-container *ngTemplateOutlet="menuItemTpl; context: { icon: 'pulse', label: 'Usage', link: '/usage' }"></ng-container>
            </ng-container>
            <ng-container *hasPermission="[userPermission.ManageUsers, userPermission.ViewUsers]">
              <ng-container *ngTemplateOutlet="menuItemTpl; context: { icon: 'userpen', label: 'User Management', link: '/users-management' }"></ng-container>
            </ng-container>
            <ng-container *hasPermission="[userPermission.ManageSystemSettings]">
              <ng-container *ngTemplateOutlet="menuItemTpl; context: { icon: 'settings', label: 'Settings', link: '/settings' }"></ng-container>
            </ng-container>
          </div>
        </nav>
      </div>

      <footer class="side-menu__footer">
        <div class="logout">
          <button class="logout-btn" data-testid="nav-logout-button" (click)="onLogout()">
            <span class="logout-label">Log Out</span>
            <fa-icon [icon]="faArrowRightFromBracket"></fa-icon>
          </button>
        </div>
      </footer>
    </aside>

    <div class="main-page" id="main">
      @if (authService.isAuthenticated$ | async) {
        <eiq-button
          class="menu-expand-btn"
          [class.hidden]="fullScreenPage$ | async"
          [class.expanded]="menuOpened$()"
          [testId]="'nav-menu-toggle'"
          [title]="'Open/Close Menu'"
          [style]="'icon'"
          [color]="'light'"
          [size]="'small'"
          [icon]="menuOpened$() ? faChevronsLeft : faChevronsRight"
          (clicked)="menuOpened$.set(!menuOpened$())"
        ></eiq-button>
      }
      <router-outlet id="main-content"></router-outlet>
    </div>
  </div>
</div>
